import type { AddressStored } from "../../types";

export type ICountries = {
  available_regions: {
    code: string;
    id: number;
  }[];
  full_name_english: string;
  full_name_locale: string;
  id: string;
  three_letter_abbreviation: string;
  two_letter_abbreviation: string;
};

export const addCountryToAddress = (address: AddressStored, countries: ICountries[]): AddressStored => {
  if (address.countryName) return address;

  const country = countries.find((_country) => _country.id === address.countryCode);
  return { ...address, countryName: country?.full_name_locale };
};
